import React from 'react';
import { ArticleTheme } from 'hooks/useArticleTheme';
import './ArticleThemeSwitch.css';

interface ArticleThemeSwitchProps {
  value: ArticleTheme;
  onChange: (theme: ArticleTheme) => void;
}

const OPTIONS: { value: ArticleTheme; label: string }[] = [
  { value: 'day', label: 'Day' },
  { value: 'night', label: 'Night' },
];

/**
 * The Day / Night reading-mode pill in the article byline (Asana 1219952231021031).
 * Two real buttons with aria-pressed inside a labelled group; colours come from the
 * article theme tokens so the pill follows the page it sits on.
 */
const ArticleThemeSwitch: React.FC<ArticleThemeSwitchProps> = ({ value, onChange }) => (
  <div className="article-theme-switch" role="group" aria-label="Reading mode">
    {OPTIONS.map((option) => (
      <button
        key={option.value}
        type="button"
        className={`article-theme-switch__button${value === option.value ? ' article-theme-switch__button--active' : ''}`}
        aria-pressed={value === option.value}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default ArticleThemeSwitch;
